import { useEffect, useRef, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { MailCheck, CircleCheck, CircleX } from 'lucide-react';
import { getErrorMessage } from '../../lib/apiClient';
import { confirmEmailVerification } from './authApi';
import AuthShell from './AuthShell';

export default function VerifyEmailPage() {
  const [params] = useSearchParams();
  const token = params.get('token') ?? '';
  const [status, setStatus] = useState(token ? 'pending' : 'missing');
  const [message, setMessage] = useState('');
  const ran = useRef(false);

  useEffect(() => {
    if (!token || ran.current) return;
    ran.current = true; // guard React 18 StrictMode double-invoke
    confirmEmailVerification(token)
      .then(() => setStatus('ok'))
      .catch((error) => {
        setStatus('error');
        setMessage(getErrorMessage(error, 'Verification failed'));
      });
  }, [token]);

  const view = {
    missing: { icon: CircleX, color: 'text-red-600', text: 'This verification link is missing its token.' },
    pending: { icon: MailCheck, color: 'text-brand-600', text: 'Verifying your email…' },
    ok: { icon: CircleCheck, color: 'text-green-600', text: 'Your email is verified. You’re all set!' },
    error: { icon: CircleX, color: 'text-red-600', text: message || 'Verification failed or the link expired.' },
  }[status];
  const Icon = view.icon;

  return (
    <AuthShell
      icon={<MailCheck className="h-7 w-7 text-brand-600" />}
      title="Email verification"
      subtitle="Confirming your address"
    >
      <div className="flex flex-col items-center gap-3 text-center">
        <Icon className={`h-10 w-10 ${view.color}`} />
        <p className="text-sm text-slate-600">{view.text}</p>
        <Link to="/files" className="mt-2 text-sm font-medium text-brand-600 hover:text-brand-700">
          Go to your files
        </Link>
      </div>
    </AuthShell>
  );
}
